import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Address, Client, Recipient, Rimset, Document, Sender, SpecialSelect, WheelNewsOrder, CityZip} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {AddressService} from '../../../services/address.service';
import {WheelNewsOrderService} from '../../../services/wheelNewsOrder.service';
import {CheckService} from '../../../services/check.service';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {MatLegacyCheckboxChange as MatCheckboxChange} from '@angular/material/legacy-checkbox';
import {MatLegacyOption as MatOption, MatLegacyOptionSelectionChange as MatOptionSelectionChange} from '@angular/material/legacy-core';
import {MatDatepicker} from '@angular/material/datepicker';
import {MatLegacyRadioButton as MatRadioButton} from '@angular/material/legacy-radio';
import {MatStepper} from '@angular/material/stepper';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DatePipe} from '@angular/common';
import * as _moment from 'moment';
import {map, startWith} from 'rxjs/operators';
import Swal from 'sweetalert2';

const moment = _moment;

class Notifications {
  value: string;
}

export const CustomFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-wheelnews-task',
  templateUrl: './wheelnews-task.component.html',
  styleUrls: ['./wheelnews-task.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: CustomFormats
    },
    [DatePipe]
  ],
})

export class WheelnewsTaskComponent implements OnInit {
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @ViewChild('elementToFocus') input: ElementRef;
  @ViewChild('clientRadio', { static: true }) clientRadio: MatRadioButton;
  @ViewChild('SpecialSelectOptions', { static: true }) SpecialSelectOptions: MatOption[];
  @ViewChild('fileDropRef') fileDropEl: ElementRef;

  public order: WheelNewsOrder;
  public translation: Translation;
  public files: any[] = [];
  public inProgress = false;

  // Sender variables
  public senderList: Address[];
  public autoCompleteSender = new UntypedFormControl();
  public filteredSenderList: Observable<Address[]>;
  public disabledSenderFields1: string;
  public disabledSenderFields2: string;
  public disabledSenderFields3: string;
  public disabledSenderFields4: string;
  public senderDropDownIsVisible = false;
  public date = new UntypedFormControl(moment());
  public tempDate: Date = new Date();
  public minDate: Date = new Date();
  public senderIsFreeData = true;
  public senderSearchList: CityZip[];
  public autoCompleteSenderSearch = new UntypedFormControl();
  public filteredSenderSearchList: Observable<CityZip[]>;
  public senderFloatLabelControl = new UntypedFormControl('auto');
  public senderSearchText = '';

  // Recipient variables
  public recipientList: Address[];
  public autoCompleteRecipient = new UntypedFormControl();
  public filteredRecipientList: Observable<Address[]>;
  public disabledRecipientFields1: string;
  public disabledRecipientFields2: string;
  public disabledRecipientFields3: string;
  public recipientDropDownIsVisible = false;
  public recipientIsFreeData = true;
  public differentRecipientAddress = false;
  public recipientSearchList: CityZip[];
  public autoCompleteRecipientSearch = new UntypedFormControl();
  public filteredRecipientSearchList: Observable<CityZip[]>;
  public recipientFloatLabelControl = new UntypedFormControl('auto');
  public recipientSearchText = '';

  // Rimset variables
  public tabs: string[];
  public rimAmountList = [1, 2, 3, 4, 5];
  public selectedRimset = new UntypedFormControl(0);

  // Other variables
  public selectedAid;
  public partnerList = sessionStorage.getItem('Addresses').split(',');
  public notifications = new Notifications()[4];

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private addressService: AddressService,
    private wheelNewsOrderService: WheelNewsOrderService,
    private datepipe: DatePipe,
    private router: Router
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(6);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.enableFields();
    this.stepper._getIndicatorType = () => 'number';

    // Remove empty items fix
    this.partnerList = this.partnerList.filter(item => item);
    this.partnerList.unshift('---');

    this.initData();
  }

  enableFields() {
    this.disabledSenderFields1 = 'false';
    this.disabledSenderFields2 = 'false';
    this.disabledSenderFields3 = 'false';
    this.disabledSenderFields4 = 'false';
    this.disabledRecipientFields1 = 'false';
    this.disabledRecipientFields2 = 'false';
    this.disabledRecipientFields3 = 'false';
  }

  initData() {
    if (sessionStorage.getItem('PrimaryAddress') === '' || sessionStorage.getItem('PrimaryAddress') === 'null') {
      this.router.navigate(['/home'], { queryParams: { message: 2 } });
    }
    const wnExternal = sessionStorage.getItem('WnExternal').toString() === 'true';
    this.order = new WheelNewsOrder();
    this.order.User = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.UserId = +sessionStorage.getItem('UserId');
    this.order.Phone = sessionStorage.getItem('Phone');
    this.order.Email = sessionStorage.getItem('Email');
    this.order.WheelnewsSpecial = sessionStorage.getItem('WheelnewsSpecial');
    this.order.DeliveryOption = 0;
    this.order.DeliveryOptionText = '';
    this.order.FreightPayerSelection = 0;
    this.order.FreightPayerAid = wnExternal ? 'unused' : JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.order.Language = localStorage.getItem('Language');
    this.order.Client = new Client();
    this.order.Client.PartnerId = wnExternal ? 0 : JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerId;
    this.order.Client.PartnerFid = wnExternal ? 'unused' : JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerFid;
    this.order.Client.PartnerAid = wnExternal ? 'unused' : JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.order.Client.Name = wnExternal ? JSON.parse(sessionStorage.getItem('WheelnewsAddress')).Company : JSON.parse(sessionStorage.getItem('PrimaryAddress')).Description;
    this.order.Client.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Client.Email = sessionStorage.getItem('Email');
    this.order.Client.Phone = sessionStorage.getItem('Phone');
    this.order.Client.AddressLine1 = wnExternal ? JSON.parse(sessionStorage.getItem('WheelnewsAddress')).StreetAndNumber : JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryStreet;
    this.order.Client.AddressLine2 = wnExternal ? JSON.parse(sessionStorage.getItem('WheelnewsAddress')).Additive : JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryAddition;
    this.order.Client.Zip = wnExternal ? +JSON.parse(sessionStorage.getItem('WheelnewsAddress')).Zip : +JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryZip;
    this.order.Client.City = wnExternal ? JSON.parse(sessionStorage.getItem('WheelnewsAddress')).City : JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryCity;
    this.order.Client.Region = wnExternal ? 'unused' : JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryRegion;
    this.order.Sender = new Sender();
    this.order.Sender.Selection = 1;
    this.order.Sender.Notification = this.translation.None;
    this.order.Sender.NotificationText = this.translation.None;
    this.order.Recipient = new Recipient();
    this.order.Recipient.Selection = 1;
    this.order.Recipient.Notification = this.translation.None;
    this.order.Recipient.NotificationText = this.translation.None;
    this.notifications = [
      {value: this.translation.None},
      {value: this.translation.FifteenMinutesBeforeNotification},
      {value: this.translation.ThirtyMinutesBeforeNotification},
      {value: this.translation.OneHourBeforeNotification}];
    this.order.RimsetList = [];
    this.order.RimsetList.push(new Rimset());
    this.order.RimsetList[this.selectedRimset.value].OrderTypes = [
      {Value: this.translation.CurbDamage, Key: 0, Disabled: false, Selected: false},
      {Value: this.translation.PaintDamage, Key: 1, Disabled: false, Selected: false},
      {Value: this.translation.ImbalanceStraightening, Key: 2, Disabled: false, Selected: false},
      {Value: this.translation.OthersPleaseDescribe, Key: 98, Disabled: false, Selected: false}];
    this.order.RimsetList[this.selectedRimset.value].Repaint = {Value: this.translation.Repaint, Key: 99, Disabled: false, Selected: false };
    this.order.RimsetList[this.selectedRimset.value].Files = [];
    this.order.WillBeBroughtByCustomer = false;
    this.order.WillBePickedUpByCustomer = false;
    this.tabs = [this.translation.Order + ' 1'];
    this.files = [];

    this.selectedAid = wnExternal ? 'unused' : JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.clientRadio.checked = true;

    this.addressService.getCityZipList().subscribe(response => {
      if (response.Ok) {
        this.senderSearchList = response.Obj;
        this.recipientSearchList = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      this.filterSenderSearchDropDown();
      this.filterRecipientSearchDropDown();
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  /* Top Radios */

  senderChangeToFreeData() {
    // Main Settings
    this.order.Sender.Selection = 1;
    this.senderIsFreeData = true;
    this.order.WillBeBroughtByCustomer = false;
    // SenderData
    this.order.Sender.PartnerId = 0;
    this.order.Sender.PartnerFid = '';
    this.order.Sender.PartnerAid = '';
    this.order.Sender.Name = '';
    this.order.Sender.Contact = '';
    this.order.Sender.Email = '';
    this.order.Sender.Phone = '';
    this.order.Sender.AddressLine1 = '';
    this.order.Sender.AddressLine2 = '';
    this.order.Sender.Zip = null;
    this.order.Sender.City = '';
    this.order.Sender.Region = '';
    // Disable / Enable
    this.disabledSenderFields1 = 'false';
    this.disabledSenderFields2 = 'false';
    this.disabledSenderFields3 = 'false';
    this.disabledSenderFields4 = 'false';
  }
  senderChangeToSelfData() {
    // Main Settings
    this.order.Sender.Selection = 0;
    this.senderIsFreeData = false;
    this.order.WillBeBroughtByCustomer = false;
    // SenderData
    this.order.Sender.PartnerId = this.order.Client.PartnerId;
    this.order.Sender.PartnerFid = this.order.Client.PartnerFid;
    this.order.Sender.PartnerAid = this.order.Client.PartnerAid;
    this.order.Sender.Name = this.order.Client.Name;
    this.order.Sender.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Sender.Email = sessionStorage.getItem('Email');
    this.order.Sender.Phone = sessionStorage.getItem('Phone');
    this.order.Sender.AddressLine1 = this.order.Client.AddressLine1;
    this.order.Sender.AddressLine2 = this.order.Client.AddressLine2;
    this.order.Sender.Zip = this.order.Client.Zip;
    this.order.Sender.City = this.order.Client.City;
    this.order.Sender.Region = this.order.Client.Region;
    // Disable / Enable
    this.disabledSenderFields1 = 'true';
    this.disabledSenderFields2 = 'true';
    this.disabledSenderFields3 = 'false';
    this.disabledSenderFields4 = 'false';
  }
  willBeBroughtByCustomerRadioChange() {
    // Main Settings
    this.order.Sender.Selection = 0;
    this.order.Recipient.Selection = 0;
    this.senderIsFreeData = false;
    this.differentRecipientAddress = false;
    this.order.WillBeBroughtByCustomer = true;
    this.order.WillBePickedUpByCustomer = true;
    // SenderData
    this.order.Sender.PartnerId = 0;
    this.order.Sender.PartnerFid = 'WHEEBUCH';
    this.order.Sender.PartnerAid = 'WHEEBUCH';
    this.order.Sender.Name = 'Wheelnews';
    this.order.Sender.Contact = 'Wheelnews';
    this.order.Sender.Email = 'info@wheelnews.ch';
    this.order.Sender.Phone = '+41 58 710 31 20';
    this.order.Sender.AddressLine1 = 'Bresteneggstrasse 1';
    this.order.Sender.AddressLine2 = '';
    this.order.Sender.Zip = 5033;
    this.order.Sender.City = 'Buchs AG';
    this.order.Sender.Region = 'AG';
    // RecipientData
    this.order.Recipient.PartnerId = 0;
    this.order.Recipient.PartnerFid = 'WHEEBUCH';
    this.order.Recipient.PartnerAid = 'WHEEBUCH';
    this.order.Recipient.Name = 'Wheelnews';
    this.order.Recipient.Contact = 'Wheelnews';
    this.order.Recipient.Email = 'info@wheelnews.ch';
    this.order.Recipient.Phone = '+41 58 710 31 20';
    this.order.Recipient.AddressLine1 = 'Bresteneggstrasse 1';
    this.order.Recipient.AddressLine2 = '';
    this.order.Recipient.Zip = 5033;
    this.order.Recipient.City = 'Buchs AG';
    this.order.Recipient.Region = 'AG';
    // Disable / Enable
    this.disabledSenderFields1 = 'true';
    this.disabledSenderFields2 = 'true';
    this.disabledSenderFields3 = 'true';
    this.disabledSenderFields4 = 'true';
  }

  /* Bottom Radios */

  sameRecipientAddressRadioChange() {
    // Main Settings
    this.order.Recipient.Selection = this.order.Sender.Selection;
    this.recipientIsFreeData = this.senderIsFreeData;
    this.differentRecipientAddress = false;
    this.order.WillBePickedUpByCustomer = false;
    this.order.WillBeBroughtByCustomer = false;
    // RecipientData
    this.order.Recipient.PartnerId = this.order.Sender.PartnerId;
    this.order.Recipient.PartnerFid = this.order.Sender.PartnerFid;
    this.order.Recipient.PartnerAid = this.order.Sender.PartnerAid;
    this.order.Recipient.Name = this.order.Sender.Name;
    this.order.Recipient.Contact = this.order.Sender.Contact;
    this.order.Recipient.Email = this.order.Sender.Email;
    this.order.Recipient.Phone = this.order.Sender.Phone;
    this.order.Recipient.AddressLine1 = this.order.Sender.AddressLine1;
    this.order.Recipient.AddressLine2 = this.order.Sender.AddressLine2;
    this.order.Recipient.Zip = this.order.Sender.Zip;
    this.order.Recipient.City = this.order.Sender.City;
    this.order.Recipient.Region = this.order.Sender.Region;
    this.order.Recipient.Notification = this.order.Sender.Notification;
    this.order.Recipient.NotificationText = this.order.Sender.NotificationText;
  }
  differentRecipientAddressRadioChange() {
    // Main settings
    this.order.Recipient.Selection = 1;
    this.recipientIsFreeData = true;
    this.differentRecipientAddress = true;
    this.order.WillBePickedUpByCustomer = false;
    // RecipientData
    this.order.Recipient.PartnerId = 0;
    this.order.Recipient.PartnerFid = '';
    this.order.Recipient.PartnerAid = '';
    this.order.Recipient.Name = '';
    this.order.Recipient.Contact = '';
    this.order.Recipient.Email = '';
    this.order.Recipient.Phone = '';
    this.order.Recipient.AddressLine1 = '';
    this.order.Recipient.AddressLine2 = '';
    this.order.Recipient.Zip = null;
    this.order.Recipient.City = '';
    this.order.Recipient.Region = '';
    this.order.Recipient.Notification = this.translation.None;
    this.order.Recipient.NotificationText = this.translation.None;
    // Disable / Enable
    this.disabledRecipientFields1 = 'false';
    this.disabledRecipientFields2 = 'false';
    this.disabledRecipientFields3 = 'false';
  }
  willBePickedUpByCustomerRadioChange() {
    // Main settings
    this.order.Recipient.Selection = 0;
    this.recipientIsFreeData = false;
    this.differentRecipientAddress = false;
    this.order.WillBePickedUpByCustomer = true;
    // RecipientData
    this.order.Recipient.PartnerFid = 'WHEEBUCH';
    this.order.Recipient.PartnerAid = 'WHEEBUCH';
    this.order.Recipient.Name = 'Wheelnews';
    this.order.Recipient.Contact = 'Wheelnews';
    this.order.Recipient.Email = 'info@wheelnews.ch';
    this.order.Recipient.Phone = '+41 58 710 31 20';
    this.order.Recipient.AddressLine1 = 'Bresteneggstrasse 1';
    this.order.Recipient.AddressLine2 = '';
    this.order.Recipient.Zip = 5033;
    this.order.Recipient.City = 'Buchs AG';
    this.order.Recipient.Region = 'AG';
    }

  filterSenderSearchDropDown() {
    this.filteredSenderSearchList = this.autoCompleteSenderSearch.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSenderSearch(value))
    );
  }
  _filterSenderSearch(value: string): CityZip[] {
    let filterValue = value;
    if (!Number(value) && value !== null) { filterValue = value.toLowerCase(); }
    return this.senderSearchList.filter(senderSearchItem =>
      senderSearchItem.City.toLowerCase().startsWith(filterValue) ||
      senderSearchItem.Zip.toLowerCase().startsWith(filterValue));
  }
  onSenderSearch(event: MatOptionSelectionChange, senderCityZip: CityZip) {
    if (event.isUserInput) {
      this.order.Sender.Zip = +senderCityZip.Zip;
      this.order.Sender.City = senderCityZip.City;
      this.order.Sender.PartnerFid = senderCityZip.ForeignId;
      this.filterSenderSearchDropDown();
    }
  }

  /* Recipient-Tab */

  recipientChangeToFreeData() {
    // Main settings
    this.order.Recipient.Selection = 1;
    this.recipientIsFreeData = true;
    // RecipientData
    this.order.Recipient.PartnerId = 0;
    this.order.Recipient.PartnerFid = '';
    this.order.Recipient.PartnerAid = '';
    this.order.Recipient.Name = '';
    this.order.Recipient.Contact = '';
    this.order.Recipient.Email = '';
    this.order.Recipient.Phone = '';
    this.order.Recipient.AddressLine1 = '';
    this.order.Recipient.AddressLine2 = '';
    this.order.Recipient.Zip = null;
    this.order.Recipient.City = '';
    this.order.Recipient.Region = '';
    // Disable / Enable
    this.disabledRecipientFields1 = 'false';
    this.disabledRecipientFields2 = 'false';
    this.disabledRecipientFields3 = 'false';
  }
  recipientChangeToSelfData() {
    // MainSettings
    this.order.Recipient.Selection = 0;
    this.recipientIsFreeData = false;
    // RecipientData
    this.order.Recipient.PartnerId = this.order.Client.PartnerId;
    this.order.Recipient.PartnerFid = this.order.Client.PartnerFid;
    this.order.Recipient.PartnerAid = this.order.Client.PartnerAid;
    this.order.Recipient.Name = this.order.Client.Name;
    this.order.Recipient.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.order.Recipient.Email = sessionStorage.getItem('Email');
    this.order.Recipient.Phone = sessionStorage.getItem('Phone');
    this.order.Recipient.AddressLine1 = this.order.Client.AddressLine1;
    this.order.Recipient.AddressLine2 = this.order.Client.AddressLine2;
    this.order.Recipient.Zip = this.order.Client.Zip;
    this.order.Recipient.City = this.order.Client.City;
    this.order.Recipient.Region = this.order.Client.Region;
    // Disable / Enable
    this.disabledRecipientFields1 = 'true';
    this.disabledRecipientFields2 = 'true';
    this.disabledRecipientFields3 = 'false';
  }
  recipientChangeToSameDataAsSender() {
    // Main Settings
    this.order.Recipient.Selection = this.order.Sender.Selection;
    this.recipientIsFreeData = this.senderIsFreeData;
    this.differentRecipientAddress = false;
    this.order.WillBePickedUpByCustomer = false;
    // RecipientData
    this.order.Recipient.PartnerId = this.order.Sender.PartnerId;
    this.order.Recipient.PartnerFid = this.order.Sender.PartnerFid;
    this.order.Recipient.PartnerAid = this.order.Sender.PartnerAid;
    this.order.Recipient.Name = this.order.Sender.Name;
    this.order.Recipient.Contact = this.order.Sender.Contact;
    this.order.Recipient.Email = this.order.Sender.Email;
    this.order.Recipient.Phone = this.order.Sender.Phone;
    this.order.Recipient.AddressLine1 = this.order.Sender.AddressLine1;
    this.order.Recipient.AddressLine2 = this.order.Sender.AddressLine2;
    this.order.Recipient.Zip = this.order.Sender.Zip;
    this.order.Recipient.City = this.order.Sender.City;
    this.order.Recipient.Region = this.order.Sender.Region;
    this.order.Recipient.Notification = this.order.Sender.Notification;
    this.order.Recipient.NotificationText = this.order.Sender.NotificationText;
    // Disable / Enable
    this.disabledRecipientFields1 = 'true';
    this.disabledRecipientFields2 = 'true';
    this.disabledRecipientFields3 = 'true';
  }

  filterRecipientSearchDropDown() {
    this.filteredRecipientSearchList = this.autoCompleteRecipientSearch.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRecipientSearch(value))
    );
  }
  _filterRecipientSearch(value: string): CityZip[] {
    let filterValue = value;
    if (!Number(value) && value !== null) { filterValue = value.toLowerCase(); }
    return this.recipientSearchList.filter(recipientSearchItem =>
      recipientSearchItem.City.toLowerCase().includes(filterValue) ||
      recipientSearchItem.Zip.toLowerCase().includes(filterValue));
  }
  onRecipientSearch(event: MatOptionSelectionChange, recipientCityZip: CityZip) {
    if (event.isUserInput) {
      this.order.Recipient.Zip = +recipientCityZip.Zip;
      this.order.Recipient.City = recipientCityZip.City;
      this.order.Recipient.PartnerFid = recipientCityZip.ForeignId;
      this.filterRecipientSearchDropDown();
    }
  }

  /* Rimset */

  addRimset() {
    this.tabs.push(this.translation.Order + (+this.selectedRimset.value + 2));
    this.order.RimsetList.push(new Rimset());
    this.selectedRimset.setValue(this.tabs.length - 1);
    if (this.selectedRimset.value < 0) { this.selectedRimset.setValue(0); }
    this.order.RimsetList[this.selectedRimset.value].OrderTypes = [
      {Value: this.translation.CurbDamage, Key: 0, Disabled: false, Selected: false},
      {Value: this.translation.PaintDamage, Key: 1, Disabled: false, Selected: false},
      {Value: this.translation.ImbalanceStraightening, Key: 2, Disabled: false, Selected: false},
      {Value: this.translation.OthersPleaseDescribe, Key: 98, Disabled: false, Selected: false}];
    this.order.RimsetList[this.selectedRimset.value].Repaint = {Value: this.translation.Repaint, Key: 99, Disabled: false, Selected: false };
    this.order.RimsetList[this.selectedRimset.value].Files = [];
    this.files = [];
  }
  removeRimset() {
    this.tabs.splice(this.selectedRimset.value, 1);
    this.order.RimsetList.splice(this.selectedRimset.value, 1);
    this.selectedRimset.setValue(this.selectedRimset.value - 1);
    if (this.selectedRimset.value < 0) { this.selectedRimset.setValue(0); }
  }
  specialCheckboxChange(e: MatCheckboxChange, s: SpecialSelect) {
    s.Selected = e.checked;
    if (s.Key === 98) { this.order.RimsetList[this.selectedRimset.value].DamageCommentTextActive = e.checked; }
    if (s.Key === 99) { this.order.RimsetList[this.selectedRimset.value].RepaintCommentTextActive = e.checked; }
  }

  /* Files */

  onFileDropped($event) {
    this.inProgress = true;
    this.prepareFilesList($event);
  }
  fileBrowserHandler(files) {
    this.inProgress = true;
    this.prepareFilesList(files);
  }
  deleteFile(index: number) {
    if (this.files[index].progress < 100) { return; }
    this.files.splice(index, 1);
    this.order.RimsetList[this.selectedRimset.value].Files.splice(index, 1);
  }
  prepareFilesList(files: Array<any>) {
    if (files.length > 5) {
      Swal.fire(this.translation.Error, this.translation.MoreThan5FilesPerSetAreNotAllowed, 'error');
      return;
    }
    for (const item of files) {
      if (item.size > 2621440) {
        Swal.fire(this.translation.Error, this.translation.FilesOver5MBAreNoteAllowed, 'error');
        return;
      }
      item.progress = 0;
      this.files.push(item);

      const reader = new FileReader();
      reader.readAsBinaryString(item);
      reader.onload = () => {
        const doc = new Document();
        doc.Base64String = btoa(reader.result.toString());
        doc.FileName = item.name;
        this.order.RimsetList[this.selectedRimset.value].Files.push(doc);
      };
    }
    this.fileDropEl.nativeElement.value = '';
    this.uploadFilesSimulator(0);
  }
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        this.inProgress = false;
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            // The smaller the fileSize, the faster the animation
            const step = this.files[index].size < 327680 ? 50 : this.files[index].size < 655360 ? 20 : this.files[index].size < 1310720 ? 10 : 5;
            this.files[index].progress += step;
          }
        }, 200);
      }
    }, 1000);
  }
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  selectedRimsetIndexChange($event: number) {
    Array.prototype.forEach.call(this.files, (file: File) => {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = () => {
        const base64string = btoa(reader.result.toString());
        const doc = new Document();
        doc.Base64String = base64string;
        doc.FileName = this.selectedRimset.value + '_' + file.name;
        this.order.RimsetList[this.selectedRimset.value].Files.push(doc);
      };
    });
    this.selectedRimset.setValue($event);
    this.files = [];
  }

  /* Confirm */

  changeDeliveryOptions(value: number, text: string) {
    this.order.DeliveryOption = value;
    this.order.DeliveryOptionText = text;
  }
  changeFreightPayer(value: number) {
    this.order.FreightPayerSelection = value;
  }
  async send() {
    switch (this.order.FreightPayerSelection) {
      case 0: this.order.FreightPayerAid = this.selectedAid; break;
      case 1: this.order.FreightPayerAid = this.order.Sender.PartnerAid; break;
      case 2: this.order.FreightPayerAid = this.order.Recipient.PartnerAid; break;
      default: this.order.FreightPayerAid = this.selectedAid; break;
    }
    this.wheelNewsOrderService.insertOrder(this.order).subscribe(async response => {
      if (response.Ok) {
        const orderIds = [];
        await response.Obj.forEach(order => {
          if (order.Message === '') {
            orderIds.push(order.Id);
          } else {
            Swal.fire(this.translation.Error, order.Message, 'error').then(r => r);
          }
        });
        if (orderIds.length > 0) { await this.router.navigate(['/home'], {queryParams: {message: 3, ids: orderIds}}); }
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { await this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  /* Others */

  validate() {
    switch (this.stepper.selectedIndex) {
      case 0:
        if (!this.differentRecipientAddress && !this.order.WillBePickedUpByCustomer) {
          this.recipientChangeToSameDataAsSender();
        }
        this.order.Sender.PickUpDateText = this.datepipe.transform(this.tempDate, 'dd.MM.yyyy');
        this.wheelNewsOrderService.validateSender(this.order).subscribe(response => {
          if (response.Ok) {
            this.differentRecipientAddress ? this.stepper.selectedIndex = this.stepper.selectedIndex + 1 : this.stepper.selectedIndex = this.stepper.selectedIndex + 2;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 1:
        this.wheelNewsOrderService.validateRecipient(this.order).subscribe(response => {
          if (response.Ok) {
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 2:
        this.wheelNewsOrderService.validateRimsets(this.order).subscribe(response => {
          if (response.Ok) {
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 3: this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
    }
  }

  back() {
    !this.differentRecipientAddress && this.stepper.selectedIndex === 2 ? this.stepper.selectedIndex = this.stepper.selectedIndex - 2 : this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
  }

  openDatePicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this.input.nativeElement.focus());
  }
}
